import { defineStyle } from '@chakra-ui/react'

import { DataTypeRendererSizes } from './dataTypeOptions'

export const pillStyles = defineStyle({
  color: 'presets.turquoise.60',
  fontWeight: '600',
})

export const getSuffixSizeStyles = (size: DataTypeRendererSizes = 'medium') => {
  return {
    large: {
      fontSize: '18px',
      fontWeight: '400',
    },
    medium: {
      fontSize: '12px',
      fontWeight: '500',
    },
    small: {
      fontSize: '10px',
    },
  }[size]
}
